import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";
import CboSeccion from './CboSeccion';
import CboDivision from "./CboDivision";
import CboTurno from "./CboTurno";
import CboCurso from "./CboCurso";
import ConfirmationModal from "./ConfirmModal";
import { formatDate, formatDNI } from "./format";

var antcodigo, antnombre, antapellido, antfnac, antfing, antdni, antseccion, antcurso, antdivision, antturno, antlegajoAnt, antfavor;

const AluDatos = (props) => {
  const [grupo, setGrupo] = useState(0);
  const [empresa, setEmpresa] = useState(0);
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [fnac, setFNac] = useState("");
  const [fing, setFIng] = useState("");
  const [dni, setDNI] = useState("");
  const [dniFormat, setDNIFormat] = useState("");
  const [seccion, setSeccion] = useState(0);
  const [curso, setCurso] = useState(0);
  const [division, setDivision] = useState(0);
  const [turno, setTurno] = useState(0);
  const [legajoAnt, setLegajoAnt] = useState("");
  const [favor, setFavor] = useState(true);
  const [backgrnd, setBackgrnd] = useState('success');

  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  // ventana modal de confirmación
  const [showConfirm, setShowConfirm] = useState(false);
  const [messageConfirm, setMessageConfirm] = useState("");

  const handleClose = () => setShowConfirm(false);
  const handleShow = () => setShowConfirm(true);



  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)
  //const [searchcodigo, setSearchCodigo] = useState("")
  //const [searchnombre, setSearchNombre] = useState("")  
  //const [searchactivo, setSearchActivo] = useState(false)  
  //const [searchgrilla, setSearchGrilla] = useState([])  
  //const [searchMessage, setSearchMessage] = useState("")

  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */
  const handleGrupoChange = (event) => {
    setGrupo(event.target.value);
  };
  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };

  const handleSeccionChange = (event) => {
    /* const val = event.target.value;
     console.log("===============Seccion onchange--", val, "--")
     setSeccion(val !== "" ? val : ""); */
    setSeccion(Number(event.target.value));
  };
  const handleDivisionChange = (event) => {
    setDivision(event.target.value);
  };
  const handleCursoChange = (event) => {
    setCurso(event.target.value);
  };

  const handleTurnoChange = (event) => {
    setTurno(event.target.value);
  };


  /* Handle de evento modelo */
  async function handleModel(e) {
    e.preventDefault()
    try {
      var json = ""
    } catch (error) {
      console.log(error);

    }
  }

  async function handleSave(e) {
    setMessageConfirm("¿Guardar los cambios?")
    handleShow();
  }

  /* Save */
  async function handleDoSave(e) {
    handleClose();
    // validar ???

    // llamo a la grabación del registro de alumno

    let unAlumno = new Object();
    unAlumno.grupo = grupo;
    unAlumno.empresa = empresa;
    unAlumno.seccion = seccion;
    unAlumno.codigo = codigo;
    unAlumno.nombre = nombre;
    unAlumno.apellido = apellido;
    unAlumno.fnac = fnac;
    unAlumno.dni = dni;
    unAlumno.fing = fing;
    unAlumno.curso = curso;
    unAlumno.division = division;
    unAlumno.turno = turno;
    unAlumno.favor = favor ? 1 : 0;

    //        addAlumno(unAlumno);

    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unAlumno);
      console.log(json);
      if (unAlumno.codigo) {
        url = `${process.env.REACT_APP_API_URL}/alu/update`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/alu/addnew`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data;
          console.log("Alumno guardado?", json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

          /* toast */
          setTextoToast(json.message);
          setShowToast(true);
          if (json.error == 0) {
            setBackgrnd('success');
          }
          else {
            setBackgrnd('danger');
          }

        })
    } catch (error) {

      console.log(error);


    }



  }

  async function handleNew(e) {
    antcodigo = codigo; antnombre = nombre; antapellido = apellido; antfnac = fnac; antfing = fing; antdni = dni;
    antseccion = seccion; antcurso = curso; antdivision = division; antturno = turno; antlegajoAnt = legajoAnt; antfavor = favor;
    setCodigo(""); setNombre(""); setApellido(""); setFNac(""); setDNI("");
    setFIng(""); setSeccion(0); setCurso(""); setDivision(""); setTurno(""); setLegajoAnt("");
    setFavor(false);
    setNotEditable(false);
  }


  async function handleCancel(e) {
    // habría que volver a los datos anteriores
    setCodigo(antcodigo); setNombre(antnombre); setApellido(antapellido); setFNac(antfnac); setDNI(antdni);
    setFIng(antfing); setSeccion(antseccion); setCurso(antcurso); setDivision(antdivision); setTurno(antturno); setLegajoAnt(antlegajoAnt);
    setFavor(antfavor);
    setNotEditable(true);
  }

  /* Editar */
  async function handleEdit(e) {
    e.preventDefault()
    try {
      antcodigo = codigo; antnombre = nombre; antapellido = apellido; antfnac = fnac; antfing = fing; antdni = dni;
      antseccion = seccion; antcurso = curso; antdivision = division; antturno = turno; antlegajoAnt = legajoAnt; antfavor = favor;
      setNotEditable(false);
    } catch (error) {
      console.log(error);

    }
  }

  async function handleFavor(e) {
    //e.preventDefault()
    // e.target.checked
    setFavor(!favor);
  }

  const location = useLocation();


  useEffect(() => {

    var { unalumno } = location.state || {};
    console.log('Alumno a mostrar:', unalumno);


    if (unalumno) {
      setGrupo(unalumno[0].Gru_IdGru);
      setEmpresa(unalumno[0].Emp_IdEmp);
      setCodigo(unalumno[0].Alu_IdAlu);
      console.log("cod alumno", unalumno[0].Alu_IdAlu);
      setNombre(unalumno[0].Alu_Nombre);
      setApellido(unalumno[0].Alu_Apellido);
      if (unalumno[0].Alu_FNac == null) {
        setFNac('');
      }
      else {
        setFNac(unalumno[0].Alu_FNac.substring(0, 10));
      }
      if (unalumno[0].Alu_FIng == null) {
        setFIng('');
      }
      else {
        setFIng(unalumno[0].Alu_FIng.substring(0, 10));
      }
      console.log("seccion ALumno:", unalumno[0].Sec_IdSec)
      setSeccion(unalumno[0].Sec_IdSec);
      setCurso(unalumno[0].Cur_IdCur);
      setDivision(unalumno[0].Div_IdDiv);
      setTurno(unalumno[0].Tur_IdTur);
      setDNI(unalumno[0].Alu_DNI);
      setDNIFormat(formatDNI(unalumno[0].Alu_DNI));
      setLegajoAnt(unalumno[0].Alu_AntLegajo);

      setFavor(unalumno[0].Alu_Favor == 1);

      setActivo(unalumno[0].Alu_Habilitado == 1);
      unalumno = null;
    }
    else {
      setCodigo("");
    }
  }, []);
  return (


    <div >





      <div className="col-xs-12 col-lg-12 col-sm-12 col-md-12">
        <form className="border border-info p-3">
          <div className="row">

            <CboGrupo
              selectedValue={grupo}
              onChange={handleGrupoChange}
              disabled={noteditable}
              grusu={props.grusu}
            />


            <CboEmpresa
              selectedValue={empresa}
              onChange={handleEmpresaChange}
              disabled={noteditable}
              grupo={grupo}
              grusu={props.grusu}
            />



            <CboSeccion
              selectedValue={seccion}
              onChange={handleSeccionChange}
              disabled={noteditable}
              grupo={grupo}
              empresa={empresa}
              grusu={props.grusu}
            />

          </div>



          <div className="row">


            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">Apellido</label>
                <input type="text" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setApellido(e.target.value) }} value={apellido} disabled={noteditable} />
              </div>
            </div>

            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">Nombre</label>
                <input type="text" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setNombre(e.target.value) }} value={nombre} disabled={noteditable} />
              </div>
            </div>


            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">F. Nacimiento</label>
                <input type="date" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setFNac(e.target.value) }} value={fnac} disabled={noteditable} />
              </div>
            </div>
            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">D.N.I.</label>
                <input type="text" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setDNI(e.target.value) }} value={noteditable ? dniFormat : dni} disabled={noteditable} />
              </div>
            </div>

            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">Fecha de Ingreso</label>
                <input type="date" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setFIng(e.target.value) }} value={fing} disabled={noteditable} />
              </div>
            </div>


            <CboCurso

              selectedValue={curso}
              onChange={handleCursoChange}
              disabled={noteditable}

              grupo={grupo}
              empresa={empresa}
              seccion={seccion}
              grusu={props.grusu}

            />

            <CboDivision
              selectedValue={division}
              onChange={handleDivisionChange}
              disabled={noteditable}
              grupo={grupo}
              empresa={empresa}
              seccion={seccion}
            />

            <CboTurno
              selectedValue={turno}
              onChange={handleTurnoChange}
              disabled={noteditable}
              grupo={grupo}
              empresa={empresa}
            />


            <div className="col-lg-2 col-sm-6">
              <div className="form-group">
                <label className="l">Legajo anterior</label>
                <input type="text" className="input-select" id="exampleInputEmail1" placeholder="" onChange={e => { setLegajoAnt(e.target.value) }} value={legajoAnt} disabled={noteditable} />
              </div>
            </div>


            <div className="col-lg-offset-0 col-lg-12 col-xs-12">
              <div className="checkbox">
                <label>
                  <input type="checkbox" value="" onClick={handleFavor} checked={favor} disabled={noteditable} />
                  &nbsp; Favorito </label>
              </div>
            </div>


            <div className="col-lg-offset-0 col-lg-12 col-xs-12">
              <div className="checkbox">
                <label>
                  <input type="checkbox" value="" checked={activo} disabled={true} />
                  &nbsp; Activo </label>
              </div>
            </div>


          </div>





          <div className="row mb-1 border-primary p-2">

            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="filtrar" id="clear" onClick={handleNew} disabled={!noteditable} >Nuevo</button>
            </div>

            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="filtrar" id="edit" onClick={handleEdit} disabled={(codigo == "") && (noteditable)}>Editar</button>
            </div>


            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="filtrar" id="grabar" onClick={handleSave} disabled={noteditable}>Guardar</button>
            </div>
            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="filtrar" id="cancelar" onClick={handleCancel} disabled={noteditable}>Cancelar</button>
            </div>
            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="filtrar" id="remove" disabled={(codigo == "") && (noteditable)}>{activo ? 'Desactivar' : 'Reactivar'}</button>
            </div>


          </div>

        </form>
      </div>






      <ToastContainer position="top-end" className="p-3" style={{ position: 'fixed', top: '120px', right: '20px', zIndex: 9999 }}>

        <Toast onClose={() => setShowToast(false)} show={showToast} delay={5000} bg={backgrnd} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>

      </ToastContainer>


      <ConfirmationModal
        show={showConfirm}
        handleClose={handleClose}
        handleConfirm={handleDoSave}
        message={messageConfirm}
      />




    </div>

  );
};

export default AluDatos;

